define('tdnavigation', ['jquery'], function ($) {

  var tdnavigation = {
    // Build a Subnavigation for small Devices
    js_buildSubNavigation: function js_buildSubNavigation() {
      var js_buildSubNavigation = $('.js_buildSubNavigation');
      var sidebar__subcategorys = $('.sidebar__subcategorys');
      var subcategory__list = $('#js_navigationSlide');
      var activeItem = $('.sidebar__item--active').last();
      var searchCategories = $('.search-result-categories');
      var deepestLevel = 0;

      var elements = "";
      var deeplevel = [];

      if (activeItem.length == 0 || searchCategories.length) {
        $('[data-deeplevel=1]').each(function (i, val) {
          elements += '<li class="sidebar__item">' + $(this).html() + '</li>';
        });
      } else {
        activeItem.find('.sidebar__subcategorys').each(function (i, val) {
          elements += '<li class="sidebar__item">' + $(this).html() + '</li>';
        });
      }

      if (elements.length > 0 && subcategory__list.children('li').length == 0) {
        //subcategory__list.append(elements);
        var countLinkElements = $(elements).find('a').length;

        subcategory__list.append(elements).find('a').removeClass('sidebar__link').addClass('navigation__link navigation__link--main');

        subcategory__list.find('li').removeClass('sidebar__item').addClass('navigation__item');
      }

      if (subcategory__list.children().length == 0 && elements.length == 0) {
        $('[data-list="subcategory"]').hide();
      }
    }
  };

  return tdnavigation;
});

